/*!
 * Local Project Js File
 *
 */

window.requestAnimFrame = (function(){
    return  window.requestAnimationFrame       ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame    ||
        window.oRequestAnimationFrame      ||
        window.msRequestAnimationFrame     ||
        function( callback ){
            window.setTimeout(callback, 1000 / 60);
        };
})();

(function () {

    "use strict";

    var myApp = {

    }

    myApp.init = function () {

        var ticking = false;
        var last_known_scroll_position;
        var header= $('#header');


        ruralApp.Flexslider.initFlex('.flexslider', { animation: 'fade' });
        ruralApp.MagnificPopup.initMagnific('.gallery', { delegate: 'a', type: 'image', gallery: { enabled: true } });

        window.addEventListener('scroll', function(e) {
            last_known_scroll_position = window.scrollY;
            if (!ticking) {
                window.requestAnimationFrame(function() {
                    checkScrollPos(last_known_scroll_position);
                });
                ticking = true;
            }
        });

        // function checkScrollPos(scroll_pos) {
        //     // var diffScroll = scrollHeight - vwH;
        //     if (scroll_pos > 40) {
        //         header.addClass('navbar-fixed-top');
        //         $('body').addClass('navbar-is-fixed');
        //     } else {
        //         header.removeClass('navbar-fixed-top');
        //         $('body').removeClass('navbar-is-fixed');
        //     }
        //     ticking = false;
        // }


        // $( window ).resize(function() {
        //     updateArrowDpto();
        //     updateArrowCat();
        //     updateArrowEsc();
        //     updateArrowBus();
        // });

        // updateArrowDpto();
        // updateArrowCat();
        // updateArrowEsc();
        // updateArrowBus();

        // function updateArrowDpto(){
        //   var destination_dpto = $('#dpto-filter').position();
        //   $('#dpto-filter-img').css({ 'top': 0, 'left': destination_dpto.left - $('#dpto-filter-img').width() });
        // }

        // function updateArrowCat(){
        //     var destination_cat = $('#cat-filter').position();
        //     $('#cat-filter-img').css({ 'top': 0, 'left': destination_cat.left - $('#cat-filter-img').width() });
        // }

        // function updateArrowEsc(){
        //     var destination_esc = $('#esc-filter').position();
        //     $('#esc-filter-img').css({ 'top': 0, 'left': destination_esc.left - $('#esc-filter-img').width() });
        // }

        // function updateArrowBus(){
        //     var destination_bus = $('#table-detalle-puy_filter').position();
        //     $('#bus-filter-img').css({ 'top': destination_bus.top - $('#bus-filter-img').height(), 'left': destination_bus.left - $('#bus-filter-img').width() });
        // }

    };




    document.addEventListener('DOMContentLoaded', function() {
        myApp.init();
    }, false);


})();
